import { IconButton, Typography } from "@mui/material";
import { FaChevronLeft } from "react-icons/fa6";
import { Link, useNavigate } from "react-router-dom";

import { Container } from "../../common/Container/Container";
import { BottomNavigator } from "./components/ButtonNavigator";
import { LeftMenu } from "./components/LeftMenu";

export function CreateYourProfile() {
	const navigate = useNavigate();

	return (
		<Container navbarOrkaProps={{ white: true }} noFooter>
			<div className="resource-detail-container">
				<LeftMenu />
				<div className="main-content">
					<div className="resource-header">
						<IconButton
							className="icon-button back-button"
							onClick={() => {
								navigate("/resources");
							}}>
							<FaChevronLeft />
						</IconButton>
						<Typography className="normal-text">Back to Resources</Typography>
					</div>

					<Typography
						className="title-text bold resource-title"
						textAlign="center"
						id="introduction">
						Create your profile
					</Typography>

					<Typography className="normal-text paragraph-top">
						Learn how to promote your skills and yourself.
					</Typography>

					<Typography className="normal-text paragraph-top">
						Your profile is your best marketing tool. Students searching for
						help can connect directly with you. Completing your profile and
						adding your services allow students to understand how you can help
						them.
					</Typography>

					<div className="section-top">
						<Typography
							className="small-title-text bold black-text underline-on-hover-link"
							component="a"
							id="account-information"
							href="#account-information">
							Account Information
						</Typography>
					</div>

					<div className="list-item first-paragraph-top">
						<div className="dot" />
						<Typography className="normal-text" flex={1}>
							We display your name as written here.
						</Typography>
					</div>

					<div className="list-item">
						<div className="dot" />
						<Typography className="normal-text" flex={1}>
							If a student contacts you or books directly, you will receive a
							notification to this email.
						</Typography>
					</div>

					<div className="section-top">
						<Typography
							className="small-title-text bold black-text underline-on-hover-link"
							component="a"
							id="profile"
							href="#profile">
							Profile
						</Typography>
					</div>

					<div className="list-item first-paragraph-top">
						<div className="dot" />
						<Typography className="normal-text" flex={1}>
							<span className="bold">Memorable Name:</span> You are more likely
							to be remembered when you emphasize a personal aspect of your
							name.
						</Typography>
					</div>

					<div className="list-item">
						<div className="dot" />
						<Typography className="normal-text" flex={1}>
							<span className="bold">Languages:</span> People are interested in
							aviation all over the world. Some may benefit from having an
							instructor who understands their language or culture.
						</Typography>
					</div>

					<div className="list-item">
						<div className="dot" />
						<Typography className="normal-text" flex={1}>
							<span className="bold">Profile Intro:</span> Brainstorm your
							strongest skills and your best achievements. What were you trained
							to do? Have experience in? Feel your competence lies? Write an
							intro tied to your services, showcasing the qualifications most
							aligned with the services you provide. Does your intro resonate
							with your services? Does it click? What about adding one of the
							keys to your student success?
						</Typography>
					</div>

					<div className="list-item">
						<div className="dot" />
						<Typography className="normal-text" flex={1}>
							<span className="bold">Select a Great Photo:</span> You should be
							the only person in the photo, centered in the frame. Portrait or
							1:1 frames work well. Avoid selfies and overly formal photos.
							Photos with an aviation background and natural daylight are great
							picks.
						</Typography>
					</div>

					<div className="list-item">
						<div className="dot" />
						<Typography className="normal-text" flex={1}>
							<span className="bold">Services:</span> Checkout{" "}
							<Link to="/resources/finding-the-training-services-that-help-you-thrive">
								Finding the training services that help you thrive
							</Link>{" "}
							to help you decide what training you want to offer. If you already
							know what services you want to provide, check out{" "}
							<Link to="/resources/how-to-deliver-a-great-service">
								How to Deliver a Great Service?
							</Link>
						</Typography>
					</div>

					<Typography className="normal-text paragraph-top">
						You can access your public profile to see how it all comes together!
						You can also use your profile and service links to promote yourself
						on social media.
					</Typography>

					<div className="section-top">
						<Typography
							className="small-title-text bold black-text underline-on-hover-link"
							component="a"
							id="logistics"
							href="#logistics">
							Connecting with Students
						</Typography>
					</div>

					<div className="list-item first-paragraph-top">
						<Typography
							className="normal-text"
							width={{ xs: "22px", md: "24px" }}>
							1.
						</Typography>
						<Typography className="normal-text" flex={1}>
							From <Link to="/marketplace">flyorka.com/marketplace</Link>,
							students search for and browse instructors and training.
						</Typography>
					</div>
					<div className="list-item">
						<Typography
							className="normal-text"
							width={{ xs: "22px", md: "24px" }}>
							2.
						</Typography>
						<Typography className="normal-text" flex={1}>
							Students can discover your profile when your services match what
							they are looking to do, obtain, or learn.
						</Typography>
					</div>
					<div className="list-item">
						<Typography
							className="normal-text"
							width={{ xs: "22px", md: "24px" }}>
							3.
						</Typography>
						<Typography className="normal-text" flex={1}>
							Students can send you a message to ask further questions or book
							your services directly.
						</Typography>
					</div>
					<div className="list-item">
						<Typography
							className="normal-text"
							width={{ xs: "22px", md: "24px" }}>
							4.
						</Typography>
						<Typography className="normal-text" flex={1}>
							You become aware of training inquiries or confirmations through
							the application messaging system and email notifications.
						</Typography>
					</div>

					<Link to="/me" className="normal-text bold yellow-text">
						Create Your Profile
					</Link>

					<BottomNavigator />
				</div>
				<div className="right-menu">
					<Typography className="big-text bold">Table of Contents</Typography>
					<div className="paragraph-top">
						<Typography
							component="a"
							href="#introduction"
							className="normal-text black-text underline-on-hover-link">
							Introduction
						</Typography>
					</div>
					<div>
						<Typography
							component="a"
							href="#account-information"
							className="normal-text black-text underline-on-hover-link">
							Account Information
						</Typography>
					</div>
					<div>
						<Typography
							component="a"
							href="#profile"
							className="normal-text black-text underline-on-hover-link">
							Profile
						</Typography>
					</div>
					<div>
						<Typography
							component="a"
							href="#connecting-with-students"
							className="normal-text black-text underline-on-hover-link">
							Connecting with Students
						</Typography>
					</div>
				</div>
			</div>
		</Container>
	);
}
